import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0 !important;
    padding: 0 !important;
    color: ${({ theme }) => theme.bodyColor};
    font-size: ${({ theme }) => theme.fontSize};
    font-family:  ${({ theme }) => theme.fontFamily};
    font-weight: 100;
  }
  html {
    position: relative;
    min-height: 100%;
  }
`;

export default GlobalStyle;
